module.exports = __webpack_public_path__ + "media/images/admin/no-image-159a50d5d94eb067ce857d1d8674950f.jpg";